import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { SolutionsFailed } from './components/SolutionsFailed';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { Audience } from './components/Audience';
import { Steps } from './components/Steps';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream flex flex-col overflow-x-hidden" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <Problem data-id="element-4" />
        <SolutionsFailed data-id="element-5" />
        <Mechanism data-id="element-6" />
        <Deliverables data-id="element-7" />
        <Audience data-id="element-8" />
        <Steps data-id="element-9" />
        <Proof data-id="element-10" />
        <FAQ data-id="element-11" />
        <Offer data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}